import { t } from "i18next"
import { toast } from "@/hooks/useToast"
import { AiResult } from "@/types/__generated__/union-types"

export const showAIErrorMessages = (errorResult: AiResult) => {
  return toast({
    description: t(`chat.ai.errors.${errorResult}`),
  })
}
